import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorDeApi } from './api/cliente.js';
import { App } from './App.js';
import './estilos.css';
import './estilos/portal.css';
import './estilos/confirmacion.css';
import './estilos/mis-citas.css';
import './estilos/reserva.css';
import './estilos/adaptable.css';

const clienteDeConsultas = new QueryClient({
  defaultOptions: {
    queries: {
      // La disponibilidad envejece rápido, así que no se cachea de más ni se
      // reintenta cuando el problema es del cliente (401, 404, 409…).
      staleTime: 15_000,
      retry: (intentos, error) => {
        if (error instanceof ErrorDeApi && error.estado >= 400 && error.estado < 500) return false;
        return intentos < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});

const raiz = document.getElementById('raiz');
if (raiz === null) throw new Error('Falta el elemento raíz en index.html');

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={clienteDeConsultas}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
